import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiMapPin, FiPhone, FiClock, FiArrowRight } = FiIcons;

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    'https://i.ibb.co/4RrcPL5H/Nashmi-barber-shop-inside-image-1.jpg',
    'https://i.ibb.co/HLj4vV96/Nashmi-barber-shop-inside-image-2.jpg',
    'https://i.ibb.co/v6hm87mj/Nashmi-barber-shop-inside-image-3.jpg',
    'https://i.ibb.co/xq3s6C97/Nashmi-barber-shop-Inside.jpg',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const reviews = [
    {
      name: "Reda Bensassi",
      rating: 5,
      text: "I recently visited this men's barbershop and I must say, my experience was nothing short of amazing. I was warmly greeted by Mohamed from India (a great professional) and attentive team.",
      time: "a year ago"
    },
    {
      name: "AHMED.A",
      rating: 5,
      text: "Best service in Dubai, very professional and amazing haircuts and face masks! Highly recommend!",
      time: "2 years ago"
    },
    {
      name: "Fahad Shamat",
      rating: 5,
      text: "Amazing gents salon in JLT, team of professionals, understands your needs. Fantastic prices and services.",
      time: "3 years ago"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero Section */}
      <section className="relative h-screen overflow-hidden">
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <motion.div
              key={index}
              className="absolute inset-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: index === currentImageIndex ? 1 : 0 }}
              transition={{ duration: 1 }}
            >
              <img
                src={image}
                alt={`Nashmi Barber Shop Interior ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/50"></div>
            </motion.div>
          ))}
        </div>

        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white px-4">
            <motion.h1
              className="text-5xl md:text-7xl font-bold mb-6"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            >
              <span className="text-luxury-gold">Premium</span> Men's Grooming
            </motion.h1>
            <motion.p
              className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.7 }}
            >
              Experience luxury and precision at Dubai's finest barbershop
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.9 }}
            >
              <Link
                to="/services"
                className="bg-luxury-gold text-black px-8 py-3 rounded-full font-semibold hover:bg-luxury-darkGold transition-colors duration-300 flex items-center justify-center space-x-2"
              >
                <span>Our Services</span>
                <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
              </Link>
              <a
                href="tel:+971507096230"
                className="border-2 border-luxury-gold text-luxury-gold px-8 py-3 rounded-full font-semibold hover:bg-luxury-gold hover:text-black transition-all duration-300"
              >
                Book Now
              </a>
            </motion.div>
          </div>
        </div>

        {/* Image Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                index === currentImageIndex ? 'bg-luxury-gold' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Quick Info */}
      <section className="py-16 bg-luxury-charcoal">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              className="text-center text-white"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiMapPin} className="w-12 h-12 text-luxury-gold mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Location</h3>
              <p className="text-gray-300">Fortune Tower, Cluster C<br />Jumeirah Lake Towers, Dubai</p>
            </motion.div>

            <motion.div
              className="text-center text-white"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiPhone} className="w-12 h-12 text-luxury-gold mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Call Us</h3>
              <p className="text-gray-300">+971 50 709 6230</p>
            </motion.div>

            <motion.div
              className="text-center text-white"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiClock} className="w-12 h-12 text-luxury-gold mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Open Hours</h3>
              <p className="text-gray-300">Daily: 9:00 AM - 11:00 PM</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Featured Services */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold mb-4">
              <span className="text-luxury-gold">Our</span> Services
            </h2>
            <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Experience premium grooming services crafted by skilled professionals
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                image: 'https://i.ibb.co/qLGgY7dH/Nashmi-barber-shop-Cutting-1.jpg',
                title: 'Premium Haircuts',
                price: 'From AED 50',
                description: 'Professional styling and cutting by expert barbers'
              },
              {
                image: 'https://i.ibb.co/C3x4vDY8/Nashmi-barber-shop-Cutting-2.jpg',
                title: 'Beard Styling',
                price: 'From AED 30',
                description: 'Precision beard trimming and styling services'
              },
              {
                image: 'https://i.ibb.co/p6G0qNWy/Nashmi-barber-shop-Cutting-3.jpg',
                title: 'Face Treatments',
                price: 'From AED 40',
                description: 'Relaxing face masks and skin treatments'
              }
            ].map((service, index) => (
              <motion.div
                key={index}
                className="bg-white dark:bg-luxury-charcoal rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                  <p className="text-luxury-gold font-bold text-lg mb-2">{service.price}</p>
                  <p className="text-gray-600 dark:text-gray-300">{service.description}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            className="text-center mt-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <Link
              to="/services"
              className="bg-luxury-gold text-black px-8 py-3 rounded-full font-semibold hover:bg-luxury-darkGold transition-colors duration-300 inline-flex items-center space-x-2"
            >
              <span>View All Services</span>
              <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-16 bg-gray-50 dark:bg-luxury-charcoal">
        <div className="container mx-auto px-4">
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold mb-4">
              <span className="text-luxury-gold">Customer</span> Reviews
            </h2>
            <p className="text-gray-600 dark:text-gray-300">What our clients say about us</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                className="bg-white dark:bg-luxury-darkCharcoal p-6 rounded-lg shadow-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="flex items-center mb-4">
                  <div className="flex space-x-1">
                    {[...Array(review.rating)].map((_, i) => (
                      <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-luxury-gold fill-current" />
                    ))}
                  </div>
                  <span className="ml-2 text-sm text-gray-500">{review.time}</span>
                </div>
                <p className="text-gray-700 dark:text-gray-300 mb-4">"{review.text}"</p>
                <p className="font-semibold text-luxury-gold">- {review.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Home;